var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EventLink',{staticClass:"city-card",attrs:{"id":`button--city-guide--${_vm.city.id}`,"event":"common.cms.link:click","linkComponent":_vm.city}},[_c('div',{staticClass:"bg-image",style:({
      backgroundImage: `url(${_vm.url})`,
    })}),_c('div',{staticClass:"city-overlay"}),_c('p',{staticClass:"city-name text3"},[_vm._v(_vm._s(_vm.city.name))]),_c('p',{staticClass:"text8"},[_vm._v(_vm._s(_vm.city.subname))])])
}
var staticRenderFns = []

export { render, staticRenderFns }